import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Main } from '../core/main.service';
import { MiscService } from './misc.service';
// import { Router } from '@angular/router';

@Component({
  selector: 'cp-branches',
  templateUrl: './branches.component.html',
})

export class BranchesComponent {
  filter: string;
  typeFilter: string;
  statusFilter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  branches: any[];

  constructor(@Inject(Restangular) public Restangular, private mainService: Main, private api: MiscService) {
    this.statusFilter = '';
    this.typeFilter = '';
    this.itemsPerPage = 10;
    this.totalItems = 0;
    this.currentPage = 1;
    this.getTransactionFilter();
  }

  getTransactionFilter() {
    this.filter = this.statusFilter + this.typeFilter;
    this.getBranches();
  }

  getBranches() {
    let j = this.itemsPerPage * this.currentPage - this.itemsPerPage;
    this.api.getBranches('page=' + this.currentPage + this.filter).subscribe((resp: any) => {
      this.branches = resp.data;
      for (let i = 0; i < this.branches.length; i++) {
        this.branches[i].no = j + 1;
        j++;
      }
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    }, (err) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'danger' });

    });
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getBranches();
  }

  changeStatus(id: any, status: any) {
    this.api.changeBranchStatus(id, status).subscribe((res: any) => {
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
      this.getBranches();
    }, (err) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });

    });
  }

  unlockView(){
    debugger;
    this.mainService.toast({ title: 'Unlocked', body: "Superadmin Previlage Unlocked!", type: 'dark' });
  }

}
